import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CommentIcon from '@material-ui/icons/Comment';
import ListOfDocumentPopUp from '../listOfDocumentsPopUp';
import RemarkPopUp from '../remarksPopUp';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Card, FormControl, InputLabel, CardContent, Typography, CardActions } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Attachment from '../../../assets/Attachment.png';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
        padding: theme.spacing(2),
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
    },
    TableHeadCss: {
        fontWeight: '700',
        fontFamily: 'Rubik',
        fontSize: '13px',
        color: '#535353',
        backgroundColor: '#f6f6f6',
    },
    scrollbarView: {
        height: '100px',
    },
    nxtLineCss: {
        '& li': {
            whiteSpace: 'pre-wrap',
        },
    },
}));

const EnhancedTableHead = (props) => {
    const { headCells, classes, action, pageName } = props;

    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                {headCells.map((header) => {
                    return (
                        <TableCell key={header.id} align="left" className={classes.TableHeadCss}>
                            {header.label}
                        </TableCell>
                    );
                })}
                {action && (
                    <>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Remarks by team
                        </TableCell>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Doc by Team
                        </TableCell>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Remarks by ITeC team
                        </TableCell>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Doc by ITeC - others
                        </TableCell>
                    </>
                )}
                {pageName && (
                    <TableCell align="left" className={classes.TableHeadCss}>
                        Remarks
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
};

const DashboardTable = (props) => {
    const { headCells, AnalaysisRows, action, pageName, addRemarks } = props;
    const [itecOpen, setItecOpen] = React.useState(false);
    const [RemarkOpen, setRemarkOpen] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState({});
    const [option, setOption] = React.useState('');
    // console.log('Option test', option);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [remarks, setRemaks] = React.useState();
    const [remarksTitle, setRemaksTitle] = React.useState('');

    const classes = useStyles();

    const DataRow = (analysisRow) => {
        return headCells.map((header) => {
            let tableData;
            //console.log(analysisRow, 'Row Data');
            tableData = (
                <TableCell align="left" key={header.id}>
                    {analysisRow[header.id]}
                </TableCell>
            );
            return tableData;
        });
    };

    const handleRelevence = (row, option) => {
        setOption(option);

        setSelectedRow(row);
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };

    const handleRemark = (row) => {
        setSelectedRow(row);
        setRemarkOpen(true);
    };

    const handleRemarkClose = () => {
        //console.log('------');
        setRemarkOpen(false);
    };

    const handleOpenDialog = (row, val) => {
        if (val === 'EM') {
            setRemaksTitle('Remarks by Team');
            // AnalaysisRows.filter((ele) => {
            setRemaks(row.remarkByCoreteam);
            // })
        } else if (val === 'itec') {
            setRemaksTitle('Remarks by ITeC others');
            // AnalaysisRows.filter((ele) => {
            setRemaks(row.remarkByItecteam);
            // })
        }
        setTimeout(() => {
            setDialogOpen(true);
        }, 200);
    };

    ////console.log(AnalaysisRows)
    return (
        <>
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table className={classes.table}>
                            <EnhancedTableHead classes={classes} headCells={headCells} action={action} pageName={pageName} />
                            <TableBody>
                                {AnalaysisRows.map((rows, index) => {
                                    const rowData = DataRow(rows);
                                    return (
                                        <TableRow hover key={index} className={classes.tableRow}>
                                            {rowData}
                                            {action && (
                                                <>
                                                    <TableCell align="left">
                                                        {rows && rows.remarkByCoreteam && rows.remarkByCoreteam.length ? (
                                                            <CommentIcon onClick={() => handleOpenDialog(rows, 'EM')} />
                                                        ) : (
                                                            <span style={{ marginLeft: '8px' }}>-</span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <img
                                                            src={Attachment}
                                                            alt="attachment"
                                                            onClick={() => handleRelevence(rows, 'core')}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {rows && rows.remarkByItecteam && rows.remarkByItecteam.length ? (
                                                            <CommentIcon onClick={() => handleOpenDialog(rows, 'itec')} />
                                                        ) : (
                                                            <span style={{ marginLeft: '8px' }}>-</span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <img
                                                            src={Attachment}
                                                            alt="attachment"
                                                            onClick={() => handleRelevence(rows, 'itec')}
                                                        />
                                                    </TableCell>
                                                </>
                                            )}
                                            {pageName && (
                                                <TableCell>
                                                    <CommentIcon onClick={() => handleRemark(rows)} />
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
                <Dialog
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    maxWidth="sm"
                    fullWidth
                    aria-labelledby="customized-dialog-title"
                >
                    <div style={{ padding: '16px 0px 16px 16px' }}>
                        <Card>
                            <CardContent className={classes.cardContent}>
                                <Typography variant="h4" className={classes.type4}>
                                    {remarksTitle}
                                </Typography>
                            </CardContent>
                            <DialogContent className={classes.scrollbarView}>
                                <div>
                                    {remarks &&
                                        remarks.map((ele) => {
                                            return (
                                                <ul
                                                    className={classes.nxtLineCss}
                                                    style={{ margin: '0px', paddingLeft: '31px', paddingBottom: '12px' }}
                                                >
                                                    <li>{ele}</li>
                                                </ul>
                                            );
                                        })}
                                </div>
                            </DialogContent>
                        </Card>
                        <CardActions className={classes.cardAction}>
                            <div>
                                <Button variant="contained" color="primary" className="txt-capitalize" onClick={() => setDialogOpen(false)}>
                                    {' '}
                                    Close
                                </Button>
                            </div>
                        </CardActions>
                    </div>
                </Dialog>
            </div>

            {itecOpen && (
                <ListOfDocumentPopUp itecOpen={itecOpen} handleItecClose={handleItecClose} selectedRow={selectedRow} option={option} />
            )}
            {RemarkOpen && (
                <RemarkPopUp
                    RemarkOpen={RemarkOpen}
                    handleRemarkClose={handleRemarkClose}
                    selectedRow={selectedRow}
                    addRemarks={addRemarks}
                    AnalaysisRows={AnalaysisRows}
                />
            )}
        </>
    );
};

export default DashboardTable;
